import { render } from "./JalizbanAnalysis.vue?vue&type=template&id=b8e652a6"
import script from "./JalizbanAnalysis.vue?vue&type=script&lang=js"
export * from "./JalizbanAnalysis.vue?vue&type=script&lang=js"

import "./JalizbanAnalysis.vue?vue&type=style&index=0&id=b8e652a6&lang=scss"
import "./JalizbanAnalysis.vue?vue&type=style&index=1&id=b8e652a6&lang=css"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__